/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Summary_AInputs */

const en_rd_summary_a = /** @type {(inputs: Rd_Summary_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready. An agent can clone this and start working.`)
};

const id_rd_summary_a = /** @type {(inputs: Rd_Summary_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap. Agent bisa langsung clone dan kerja.`)
};

/**
* | output |
* | --- |
* | "Ready. An agent can clone this and start working." |
*
* @param {Rd_Summary_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_summary_a = /** @type {((inputs?: Rd_Summary_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Summary_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_summary_a(inputs)
	return en_rd_summary_a(inputs)
});